import { $divaltoCodes } from '@/services/'

const module = {
    namespaced: true,

    state: {
        items: [],
        item: {},
        meta: { pagination: {} }
    },

    getters: {
        items: state => state.items,
        item: state => state.item,
        meta: state => state.meta
    },

    mutations: {
        ITEMS(state, value) {
            state.items = value
        },

        ITEM(state, value) {
            state.item = value
        },

        ADD_ITEM(state, value) {
            state.items.push(value)
        },

        META(state, meta) {
            state.meta = meta
        },

        REMOVE_ITEM(state, id) {
            state.items = state.items.filter(item => item.id !== id);
        },

        UPDATE_ITEM(state, updatedItem) {
            const index = state.items.findIndex(item => item.id === updatedItem.id);
            if (index !== -1) {
                state.items.splice(index, 1, updatedItem);
            }
        },
        BULK_DELETE_ITEMS(state, ids){
            state.items = state.items.filter(item => !ids.includes(item.id))
        }
    },

    actions: {
        all({ commit }, { config = {} } = {}) {
            return $divaltoCodes.all(config).then(function (res) {
                let { data, meta } = res.data
                commit('ITEMS', data)
                commit('META', meta)
                return res.data
            }).catch(function (error) {
                console.error('[client.store/actions/all]::Error', error);
                throw error;
            })
        },

        createCode({ commit, dispatch }, payload) {
            return $divaltoCodes.createCode(payload)
                .then(res => {
                    commit('ADD_ITEM', res.data);
                    return dispatch('all', { config: {} });
                })
                .catch(error => {
                    console.error('[client.store/actions/createCode]::Error', error);
                    throw error;
                });
        },

        deleteCode({ commit, dispatch }, id) {
            return $divaltoCodes.deleteCode(id)
                .then(() => {
                    commit('REMOVE_ITEM', id);
                    dispatch('all', { config: {} });
                })
                .catch(error => {
                    console.error('[client.store/actions/deleteCode]::Error', error);
                    throw error;
                });
        },

        updateCode({ commit, dispatch }, updatedItem) {
            return $divaltoCodes.updateCode(updatedItem.id, updatedItem)
                .then(function (res) {
                    commit('UPDATE_ITEM', res.data);
                    return dispatch('all', { config: {} });
                })
                .catch(function (error) {
                    console.error('[client.store/actions/updateCode]::Error', error);
                    throw error;
                });
        },

        bulkDeleteCodes({commit, dispatch}, idsToDelete) {
            return $divaltoCodes.bulkDeleteCodes(idsToDelete)
                .then(function (res) {
                    commit('BULK_DELETE_ITEMS', idsToDelete);
                    dispatch('all', { config: {} });
                    console.log("codes deleted from store")
                })
                .catch(function (error) {
                    console.error('[client.store/actions/bulkDeleteCodes]::Error', error);
                    throw error;
                });
        }
    }
}

export default module